import { MangoTurnBack, MangoButton, ButtonLink } from '@intellihr/blueberry'
import { useNavigate } from 'react-router-dom'

interface IGenericErrorTurnbackProps {
  mangoButton?: {
    onClick?: () => void
    href?: string
    key: string
    variant: string
    testId: string
    actionType?: string
    buttonText: string
  }
  mangoTurnBack: {
    description?: React.ReactNode[] | React.ReactNode
    title: string
    testId?: string
    variant: string
  }
  mangoButtonLink?: {
    key: string
    testId: string
    variant: string
    href: string
    target?: string
    text: string
  }
}

const GenericErrorTurnback: React.FC<IGenericErrorTurnbackProps> = ({
  mangoButton,
  mangoTurnBack,
  mangoButtonLink,
}) => {
  const navigate = useNavigate()
  const refresh = () => {
    navigate(0)
  }

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        padding: '3rem 1.5rem',
      }}
    >
      <MangoTurnBack
        testId={mangoTurnBack.testId}
        variant={mangoTurnBack.variant}
        title={mangoTurnBack.title}
        description={mangoTurnBack.description}
        actions={[
          mangoButton ? (
            <MangoButton
              testId={mangoButton.testId}
              key={mangoButton.key}
              variant={mangoButton.variant}
              href={mangoButton.href}
              onClick={mangoButton.actionType === 'refresh' ? refresh : mangoButton.onClick}
            >
              {mangoButton.buttonText}
            </MangoButton>
          ) : null,
          mangoButtonLink ? (
            <ButtonLink
              key={mangoButtonLink.key}
              variant={mangoButtonLink.variant}
              testId={mangoButtonLink.testId}
              href={mangoButtonLink.href}
              target={mangoButtonLink.target}
            >
              {mangoButtonLink.text}
            </ButtonLink>
          ) : null,
        ]}
      />
    </div>
  )
}

export default GenericErrorTurnback
